<template>
  <div class="" data-testid="financialclose_component_infomanager_bulkupload">
    <v-btn color="secondaryBtn" class="mr-1 px-4 py-1 "  @click="dialog = true; resetData()" data-testid="financialclose_component_infomanager_bulkupload__open-btn">
      <v-icon class="pr-2">mdi-file-document-plus-outline</v-icon>
      <span class="">Bulk Upload</span>
    </v-btn>
    <lb-drawer v-model="dialog" :Maxwidth="(uploaddata.length > 0) ? '1665' : '700'"
      heading="Bulk Upload" :loading="loading" data-testid="financialclose_component_infomanager_bulkupload__drawer">
      <template v-slot:body>
        <div>
          <div class="text-center mb-1 d-flex justify-space-between align-center" >
            <p class="ma-0 pa-0" v-if="uploaddata.length === 0" >Upload your document</p>
            <p class="ma-0 pa-0 font-weight-bold" v-else>Preview</p>
            <div class="d-flex align-center justify-center file-upload-btn" data-testid="financialclose_component_infomanager_bulkupload__drawer-header-btns">
              <v-btn color="white" v-if="uploaddata.length>0 || reUpload"  class="ml-2 d-flex align-center  justify-space-between secondaryBtn"
                @click="reuploadDoc()" data-testid="financialclose_component_infomanager_bulkupload__reupload-btn"> <v-icon class="pr-1">mdi-reload</v-icon> <p class="ma-0 pa-0"><span>Re-Upload</span></p></v-btn>
              <v-btn  class="ml-2 d-flex align-center  justify-space-between secondaryBtn"
              @click="$nova.downloadFile('', {}, '/v2/financialclose/masters/informationmanager/getbulksubmittemplate')" data-testid="financialclose_component_infomanager_bulkupload__download-template-btn"> <v-icon class="pt-1 pr-1">mdi-tray-arrow-down</v-icon> <p class="ma-0 pa-0"><span>Download Template</span></p></v-btn>
            </div>
          </div>
          <div class="" v-if="uploaddata.length>0 " >
            <v-checkbox @change="dataOnlyWithError=!dataOnlyWithError"  class="my-1 mb-6" color="caccounting" hide-details> <template v-slot:label>
                <span>Show only items with errors</span>
              </template> </v-checkbox>
          </div>
          <div class="d-flex align-center justify-center mt-4" v-if="uploaddata.length === 0">
              <DragDropfile hidedetails :files="filesbulk" @update:files="updateFilesBulk" data-testid="financialclose_component_infomanager_bulkupload__dragdrop" />
          </div>
        </div>
        <div v-if="uploaddata.length > 0" class="mt-3  radius-small">
          <v-simple-table dense class="radius-small border-on simple-table " style="max-height:73vh; overflow:scroll" data-testid="financialclose_component_infomanager_bulkupload__table">
            <template v-slot:default>
              <thead class="tableHeaderBg">
                <th v-for="(item,index) in tableheader" :key="index" class="text-left pa-2 border-right-data tableHeaderBg" :scope="item.value">{{ item.name }}</th>
              </thead>
              <v-slide-y-transition class="" group tag="tbody" style="overflow:hidden !important;">
                <tr v-for="(v, k) in filteredData" :key="k" class="" data-testid="financialclose_component_infomanager_bulkupload__table-row">
                  <td>{{k+1}}</td>
                  <template v-for="(vv, kk) in v">
                    <!-- Skip internal properties prefixed with underscore -->
                    <template v-if="!kk.startsWith('_')">
                    <td v-if="errorsonly[k][kk]" :key="kk + '-error'" class="font-size-xm pa-0 font-weight-bold border-right-data" data-testid="financialclose_component_infomanager_bulkupload__table-error-cell">
                      <div class="all-width all-height" style="border: 1px solid #F3B9BA">
                          <div v-if="kk === 'checklistref' && vv && vv.length > 0" class="d-flex flex-wrap pa-2" style="gap: 4px;">
                            <span v-for="(item, index) in vv" :key="index" class="pa-1 px-2 caccounting--text caccounting-background radius-mini text-no-wrap">{{ item }}</span>
                          </div>
                         
                          <div v-else class="two-line-clamp">{{errorsonly[k][kk]}}</div>
                        </div>
                    </td>
                    <td v-else :key="kk" class="border-right-data">
                      <div v-if="kk === 'checklistref' && vv && vv.length > 0" class="d-flex flex-wrap pa-2" style="gap: 4px;">
                        <span v-for="(item, index) in vv" :key="index" class="pa-1 px-2 caccounting--text caccounting-background radius-mini text-no-wrap">{{ item }}</span>
                      </div>
                      <div v-else-if="kk === 'checklistref'"><!-- Empty cell for empty checklistref --></div>
                      <div v-else class="two-line-clamp">{{ vv }}</div>
                    </td>
                    </template>
                  </template>
                </tr>
              </v-slide-y-transition>
            </template>
          </v-simple-table>
        </div>
        
        <!-- Error Messages Section -->
        <div v-if="errorFlag || headerErrorMessages.length > 0" class="error--text ma-0 pa-0 mt-4">
          <!-- General Error Message -->
          <p v-if="errorFlag" class="font-size-xm" data-testid="financialclose_component_infomanager_bulkupload__error-msg">
            *These are fields where errors exist / information is missing. Please rectify and re-upload to continue.
          </p>
          
          <!-- Header Errors -->
          <div v-if="headerErrorMessages.length > 0" class="ma-0 pa-0 mt-2 font-size-xm" data-testid="financialclose_component_infomanager_bulkupload__header-errors">
            <strong>Header Issues Detected:</strong>
            <div
              :style="headerErrorMessages.length > 2
              ? 'overflow-y:auto; scrollbar-width:thin;'
              : ''"
              class="mt-1 pr-1"
              data-testid="financialclose_component_infomanager_bulkupload__header-errors-list"
            >
              <div v-for="(msg,index) in headerErrorMessages" :key="index" class="mb-1 noTransform" :data-testid="`financialclose_component_infomanager_bulkupload__header-error-${index}`">
                - {{ msg }}
              </div>
            </div>
          </div>
          
          <!-- Data Errors -->
          <div v-if="dataErrorMessages.length > 0" class="ma-0 pa-0 mt-2 font-size-xm" data-testid="financialclose_component_infomanager_bulkupload__data-errors">
            <strong>Data Errors:</strong>
            <div class="mt-1 pr-1">
              <div v-for="(msg, index) in dataErrorMessages" :key="index" class="mb-1 noTransform" :data-testid="`financialclose_component_infomanager_bulkupload__data-error-${index}`">
                - {{ msg }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <div class="">
        </div>
        <v-spacer></v-spacer>
        <v-btn class="secondaryBtn" v-if="uploaddata.length > 0" @click="dialog = false; resetData()" data-testid="financialclose_component_infomanager_bulkupload__cancel-button"><span>Cancel</span></v-btn>
       <v-btn color="primary" v-if="!errorFlag" @click="uploadData" class="white--text" data-testid="financialclose_component_infomanager_bulkupload__upload-button"><span>Upload</span></v-btn>
      </template>
    </lb-drawer>
  </div>
</template>

<script>
import DragDropfile from '../../../../views/Inputs/DragDropfile.vue';
import { sanitizePriority, sanitizeType, trimInput, sanitizeChecklistRef } from '../../utils/bulkUploadValidation';

export default {
  name: 'financialclose_component_checklist_bulkupload',
  props: {
    /**
     * Checklist data from parent component for validating task references
     */
    checklist: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      right: "financialclose_master_checklist",
      // generateddescription: "",
      file: null,
      fileprocessing: {},
      displaycolumns: ['type', 'category', 'description', 'info_owner_name', 'info_owner_email', 'urgent','checklistref','duedate'],
      flag: false,
      uploaddata: [],
      dataerror: [],
      dialog: false,
      loading: false,
      filesbulk: [],
      reUpload:false,
      tableheader:[
        {
          name:"S No",
          value:"sno"
        },
        {
          name:"Request Information",
          value:"requested_info"
        },
        {
          name:"Type",
          value:"type"
        },
        {
          name:"Classification",
          value:"classification"
        },
        {
          name:"Requested From",
          value:"info_owner_name"
        },
        {
          name:"Email ID",
          value:"info_owner_email"
        },
        {
          name:"Tasks Linked (Refs)",
          value:"checklistref"
        },
        {
          name:"Priority",
          value:"priority"
        },
        {
          name:"Due Days",
          value:"duedate"
        }
      ],
      dataOnlyWithError:false,
      dataWithNoErros:[],
      errorsonly:[],
      errorFlag:false,
      headerErrorMessages: [],
      dataErrorMessages: []
    }
  },
  created() {
  },
  components:{
    DragDropfile
  },
  activated() {
  },
  methods: {
    init() {
    },

    /**
     * Validate and map task references to checklist IDs
     * @param {Array} refs - Array of task reference strings
     * @param {Number} rowNumber - Row number for error messages
     * @returns {Object} { tasklist: Array, errors: Array, warnings: Array }
     */
    validateAndMapTaskRefs(refs, rowNumber) {
      const tasklist = [];
      const errors = [];
      const warnings = [];
      
      if (!refs || refs.length === 0) {
        return { tasklist, errors, warnings };
      }

      // Warn if checklist is empty - task references cannot be validated
      if (!this.checklist || this.checklist.length === 0) {
        console.warn('[BulkUploadInformationManager]: Checklist prop is empty. Task references cannot be validated.');
        warnings.push(`Row ${rowNumber}: Task references provided but checklist data is unavailable for validation`);
        return { tasklist, errors, warnings };
      }

      refs.forEach(ref => {
        const task = this.checklist.find(t => t.ref === ref);
        if (task) {
          tasklist.push({ checklist_id: task._id });
        } else {
          errors.push(`Row ${rowNumber}: Task reference '${ref}' not found in masters`);
        }
      });

      return { tasklist, errors, warnings };
    },

    readFile(key) {
      let file = this.filesbulk[0];
      if ((file || {}).name && (this.fileprocessing[key] || 0) === 0) {
        // Updated headers - removed Location column
        let headings = ['Request Information', 'Type', 'Classification', 'Requested From', 'Email ID', 'Tasks Linked', 'Priority', 'Due Days'];
        this.loading = true;
        this.fileprocessing[key] = 1;
        let ext = ((file || {}).name || "").split(".").pop();
        
        Promise.resolve().then(() => {
          if (["xlsx", "xls", "xlsm", "xlsb"].indexOf(ext) === -1) {
            throw new Error("Only xlsx, xls, xlsm, xlsb file extension supported");
          }
          return this.$nova.readExcelFile(file, "TOP SHEET");
        }).then(dt => {
          const actualHeaders = dt[0] || [];
          
          // Check if headers match
          if (JSON.stringify(actualHeaders) === JSON.stringify(headings)) {
            let filedata = [];
            let errordata = [];
            const validationErrors = [];
            this.flag = false;
            this.errorFlag = false;
            this.headerErrorMessages = [];
            this.dataErrorMessages = [];
            
            for (let i = 0; i < dt.length; i++) {
              if (i > 0 && dt[i].length > 0) {
                const el = dt[i];
                const rowNumber = i; // Excel row number (1-based, accounting for header)
                
                // Sanitize and validate type
                const typeResult = sanitizeType(el[1]);
                
                // Sanitize and validate priority (index updated - was 7, now 6)
                const priorityResult = sanitizePriority(el[6]);
                
                // Parse task references
                const checklistRefs = sanitizeChecklistRef(el[5]);
                
                // Validate and map task references to IDs
                const taskValidation = this.validateAndMapTaskRefs(checklistRefs, rowNumber);
                
                // Row data for display - tasklist is NOT included here to avoid column shift
                // tasklist will be mapped during uploadData() transformation
                let rowdata = { 
                  "requested_info": trimInput(el[0]), 
                  "type": typeResult.value, 
                  "classification": trimInput(el[2]), 
                  "info_owner_name": trimInput(el[3]), 
                  "info_owner_email": trimInput(el[4]), 
                  "checklistref": checklistRefs, // Keep for display
                  "_tasklist": taskValidation.tasklist, // Prefixed with _ to store for API, not displayed
                  "priority": priorityResult.value,
                  "duedate": trimInput(el[7]) // Index updated - was 8, now 7
                };
                  
                let errors = {};
                
                // Required field validations
                if (rowdata.classification === "") {
                  errors["classification"] = " ";
                  validationErrors.push(`Row ${rowNumber}: Classification is required`);
                }
                if (rowdata.requested_info === "") {
                  errors["requested_info"] = " ";
                  validationErrors.push(`Row ${rowNumber}: Request Information is required`);
                }
                if (rowdata.info_owner_name === "") {
                  errors["info_owner_name"] = " ";
                  validationErrors.push(`Row ${rowNumber}: Requested From is required`);
                }
                if (rowdata.info_owner_email === "") {
                  errors["info_owner_email"] = " ";
                  validationErrors.push(`Row ${rowNumber}: Email ID is required`);
                }
                
                // Type validation error
                if (typeResult.error) {
                  errors["type"] = typeResult.error;
                  validationErrors.push(`Row ${rowNumber}: ${typeResult.error}`);
                }
                
                // Priority validation error
                if (priorityResult.error) {
                  errors["priority"] = priorityResult.error;
                  validationErrors.push(`Row ${rowNumber}: ${priorityResult.error}`);
                }
                
                // Task reference validation errors
                if (taskValidation.errors.length > 0) {
                  errors["checklistref"] = "Invalid task reference(s)";
                  validationErrors.push(...taskValidation.errors);
                }
                
                // Task reference validation warnings (e.g., empty checklist)
                if (taskValidation.warnings && taskValidation.warnings.length > 0) {
                  validationErrors.push(...taskValidation.warnings);
                }
                
                if (Object.keys(errors).length > 0) this.flag = true;
                filedata.push(rowdata);
                if (Object.keys(errors).length > 0) {
                  this.errorFlag = true;
                }
                errordata.push(errors);
              }
            }
            
            // Set data error messages if there are validation errors
            if (validationErrors.length > 0) {
              this.dataErrorMessages = validationErrors;
            }
            
            this.uploaddata = filedata;
            this.dataerror = errordata;
            this.dataWithNoErros = filedata;
            this.errorsonly = errordata;
            this.dialog = true;
          } else {
            // Show header mismatch errors one by one in drawer
            this.headerErrorMessages = [
              'Column headers mismatch detected:',
              `Expected headers: '${headings.join("', '")}'`,
              `Found headers: '${actualHeaders.join("', '")}'`,
              'Please ensure columns are in the correct order.'
            ];
            this.errorFlag = true;
            this.uploaddata = [];
            this.dataerror = [];
            this.errorsonly = [];
            this.dialog = true;
          }
        }).catch(err => {
          // Show error in drawer instead of toast
          console.log('[BulkUploadInformationManager]:', err);
          this.dataErrorMessages = [err.message || err.toString() || "Unknown error!"];
          this.errorFlag = true;
          this.uploaddata = [];
          this.filesbulk = [];
          this.reUpload = true;
          this.dialog = true;
        }).finally(() => {
          this.file = null;
          this.fileprocessing[key] = 0;
          this.loading = false;
        });
      }
    },
    uploadData() {
      this.loading = true;
      
      // Transform data to API format - map fields and include tasklist
      const apiData = this.dataWithNoErros.map(row => ({
        description: row.requested_info,
        type: row.type,
        category: row.classification,
        info_owner_name: row.info_owner_name,
        info_owner_email: row.info_owner_email,
        tasklist: row._tasklist || [], // Use tasklist with checklist_id objects
        priority: row.priority,
        duedate: row.duedate
      }));
      
      this.axios.post("/v2/financialclose/masters/informationmanager/bulkadd", { data: apiData }).then(dt => {
        if (dt.data.status === "success") {
          this.dialog = false;
          this.$emit('reload');
          this.$store.commit("sbSuccess", "Information Requirement uploaded successfully");
        } else {
          // Parse validation errors if available
          if (dt.data.data && Array.isArray(dt.data.data) && dt.data.data.length > 0) {
            const errorMessages = [];
            
            dt.data.data.forEach(errorObj => {
              // Each errorObj has a key like "index0", "index1", etc.
              Object.keys(errorObj).forEach(indexKey => {
                // Extract the row number from the index key (e.g., "index0" -> 0)
                const rowNum = parseInt(indexKey.replace('index', '')) + 1; // +1 for 1-based row numbering
                const fieldErrors = errorObj[indexKey];
                
                // Process each field's errors
                Object.keys(fieldErrors).forEach(fieldName => {
                  const errors = fieldErrors[fieldName];
                  if (Array.isArray(errors)) {
                    errors.forEach(errMsg => {
                      errorMessages.push(`Row ${rowNum}: ${fieldName} - ${errMsg}`);
                    });
                  }
                });
              });
            });
            
            this.dataErrorMessages = errorMessages;
          } else {
            // Fallback to generic error message
            const errorMessage = dt.data.message || "Error uploading Information Requirement";
            this.dataErrorMessages = [errorMessage];
          }
          
          this.errorFlag = true;
          throw new Error(dt.data.message || "Validation error");
        }
      }).catch(err => {
        // Show error in drawer instead of toast
        console.log(err);
        if (!this.dataErrorMessages.length) {
          this.dataErrorMessages = [err.message || err.toString() || "Unknown error!"];
          this.errorFlag = true;
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    updateFilesBulk(newFilesBulk) {
      this.filesbulk = newFilesBulk;
      this.readFile('file')
      this.reUpload=true

   },
   reuploadDoc(){
    this.uploaddata = [];
    this.dataerror = [];
    this.errorFlag = false;
    this.headerErrorMessages = [];
    this.dataErrorMessages = [];
   },
   reuploadfile(event){
    this.uploadData=[]
    this.filesbulk= event.target.files
    this.readFile('file')
   },
   resetData(){
    this.uploaddata = [];
    this.reUpload = false;
    this.file = null; 
    this.dataerror = [];
    this.headerErrorMessages = [];
    this.dataErrorMessages = [];
    this.errorFlag = false;
    this.dataWithNoErros = [];
    this.errorsonly = [];
   },
  },
  computed:{

    filteredData() {
      if (this.dataOnlyWithError) {
      return this.uploaddata.filter((_, rowIndex) =>
          Object.values(this.dataerror[rowIndex]).some((error) => error)
        );
    }
    return this.uploaddata; // Return all rows if not filtering errors
      }
  },
  watch: {
    dataOnlyWithError(newVal) {
    if (newVal) {
      this.errorsonly = this.dataerror.filter(item => Object.keys(item).length > 0);
    } else {
      this.errorsonly = this.dataerror;
    }
  }
  }
}
</script>
